import { TrackerEvent } from '../utils/events/tracker-factory';

export enum BeaconEventMarketingPageElementType {
  cardinteractive = 'card-interactive',
  videobutton = 'video-button',
  buttonprimary = 'button-primary',
  linkdropdown = 'link-dropdown',
  buttonsecondary = 'button-secondary',
  link = 'link',
  image = 'image',
  accordion = 'accordion'
}

export enum BeaconEventMarketingPageElementLocation {
  nav = 'nav',
  navsub = 'nav-sub',
  hero = 'hero',
  body = 'body',
  prefooter = 'prefooter',
  footer = 'footer'
}

// There are many more types in this enum, but they are used inside of the product
// we only need add marketing types here.
// Side note: the beacon event in the explorer is called "Modal Name"
// but within the code it is called "Modal Type"
export enum BeaconEventModalName {
  bounceDetection = 'bounce detection'
}

export enum BeaconEventInteractedWithModalAction {
  clickedFinish = 'clicked finish',
  proceededToNextStage = 'proceeded to next stage',
  clickedOtherButton = 'clicked other button',
  proceededWithDemoFlow = 'proceeded with demo flow',
  clickedLink = 'clicked link',
  clickedCancel = 'clicked cancel',
  clickedSeeExample = 'clicked see example',
  clickedStartOver = 'clicked start over',
  clickedBack = 'clicked back',
  closedModal = 'closed modal'
}

export enum BeaconEventErrorMessageType {
  marketoForm = 'marketo form',
  accountCreation = 'account creation',
  paymentAppPage = 'payment app page',
  login = 'login',
  loginPage = 'login page',
  recurly = 'recurly',
  billingInfo = 'billing info',
}

export interface BeaconEvent extends TrackerEvent {
  elementLocation: BeaconEventMarketingPageElementLocation;
  elementDetail: string;
  elementType: BeaconEventMarketingPageElementType;
};

export interface ShownErrorMessageEvent extends TrackerEvent {
  anonymousId: string;
  messageText: string;
  errorType: BeaconEventErrorMessageType;
};
